import { Badge } from "../ui/Badge.js";
import type { Plakietka } from "../../lib/trening.js";

/**
 * Plakietka statusu albo oceny w treningu (BD-1, BD-2). Kolor nigdy nie niesie znaczenia sam (ST-3): zawsze jest slowo
 * ("Trwa", "Dobrze", "Za mało danych", "Do poprawy"). Ocena jest zlota (najlepsze), szara (do wymiany) albo bez
 * oznaczenia (srodek), wg lib/trening.ts. "Za mało danych" jest neutralna, bo to brak oceny, nie zla ocena.
 */
export function PlakietkaOceny({ plakietka }: { plakietka: Plakietka }): React.JSX.Element {
  return (
    <Badge wariant={plakietka.wariant} kropka>
      {plakietka.etykieta}
    </Badge>
  );
}

/**
 * Duza plakietka oceny koncowej (karta "Twoja ocena"). Te same tokeny oceny co Badge (--ocena-*: zloto i szarosc,
 * neutralnie srodek i brak oceny), wiekszy rozmiar. Wariant idzie w `data-variant`, kolory w trening.css. Zlota i szara
 * maja kropke jak mala plakietka: szary tint jest bardzo blisko neutralnego, wiec "Słabo" od "Średnio" odroznia tez
 * ksztalt, nie tylko slowo.
 */
export function DuzaPlakietkaOceny({ plakietka }: { plakietka: Plakietka }): React.JSX.Element {
  const zKropka = plakietka.wariant === "zloto" || plakietka.wariant === "szarosc";
  return (
    <span className="trening-ocena" data-variant={plakietka.wariant}>
      {zKropka && <span className="trening-ocena__kropka" aria-hidden="true" />}
      {plakietka.etykieta}
    </span>
  );
}
